import http from "@/http";
import * as types from "./types";

const actions = {
  [types.GET_COMPONENT_GROUPING_BY_SWATCH](context, {swatchId, componentName}) {
    const bucket = this.state.endPoints.customizer.componentConfigGroup;
    const model = this.state.utils.pdm.sku;
    const url = `${bucket}${model}/${componentName}/${swatchId}`;
    return new Promise((resolve, reject) => {
      const group = context.state.componentGroups[componentName] && context.state.componentGroups[componentName][swatchId];
      if (group || group === "") {
        resolve(group);
      } else {
        http.get(url).then(response =>{
          context.commit(types.SET_COMPONENT_GROUPING_BY_SWATCH, {group: response.data, componentName, swatchId});
          resolve(response.data);
        }).catch(reject)
      }
    });
  }
};

export default actions;
